import styled from '@emotion/styled'
import { breakpoints } from '~/utils/styles'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0;

  &:last-child {
    border-bottom: none;
  }
`

export const Meta = styled.div`
  padding-left: 15px;
  padding-right: 110px;
  box-sizing: border-box;
  width: calc(100% - 100px);

  a {
    color: currentColor;
    text-decoration: none;
  }

  h3 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 20px;
    letter-spacing: 0.5px;
    font-family: 'SohneBreit';
  }

  .variant {
    font-size: 80%;
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14px;
    width: 100%;
    padding-right: 0;
    width: calc(100% - 80px);

    h3 {
      font-size: 16px;
    }
  }
`

export const ImageContainer = styled.div`
  width: 100px;
  height: 100px;
  position: relative;

  .counter {
    position: absolute;
    top: 50%;
    margin-top: -15px;
    z-index: 1;
    left: -15px;
  }

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    object-fit: contain;
    left: 0;
  }

  @media (max-width: ${breakpoints.s}px) {
    width: 80px;
    height: 80px;
  }
`

export const Remove = styled.div`
  position: absolute;
  top: 50%;
  height: 30px;
  margin-top: -15px;
  right: 0;
  display: flex;

  @media (max-width: ${breakpoints.s}px) {
    position: static;
    margin: 10px 0 0;
    padding-left: 80px;
  }
`

export const RemoveButton = styled.button`
  font-family: 'SohneBreit';
  letter-spacing: 1px;
  font-size: 14px;
  border: none;
  color: #215041;
  appearance: none;
  background: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: all 100ms ease-in-out;
  margin-left: 20px;

  &:hover {
    color: red;
    opacity: 1;
  }

  @media (max-width: ${breakpoints.s}px) {
    font-size: 12px;
  }
`

export const Price = styled.div`
  font-family: 'SohneBreit';
  letter-spacing: 1px;
  font-size: 16px;

  @media (max-width: ${breakpoints.s}px) {
    font-size: 14htmlpx;
  }
`

export const Increment = styled.button`
  border-radius: 20px;
  background: #edebe0;
  width: 30px;
  height: 30px;
  border: none;
  outline: none;
  margin-left: 10px;
  position: relative;
  cursor: pointer;

  &:hover {
    background: #d16643;
    &:before,
    &:after {
      background: white;
    }
  }

  &:before,
  &:after {
    content: '';
    background: black;
    width: 40%;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    height: 2px;
    left: 30%;
    border-radius: 2px;
  }

  &:after {
    transform: rotate(90deg);
  }

  @media (max-width: ${breakpoints.s}px) {
    width: 28px;
    height: 28px;
  }
`

export const Decrement = styled.button`
  border-radius: 20px;
  background: #edebe0;
  width: 30px;
  height: 30px;
  border: none;
  outline: none;
  margin-left: 10px;
  position: relative;
  cursor: pointer;

  &:hover {
    background: #d16643;
    &:before,
    &:after {
      background: white;
    }
  }

  &:after {
    content: '';
    background: black;
    width: 40%;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    height: 2px;
    left: 30%;
    border-radius: 2px;
  }

  @media (max-width: ${breakpoints.s}px) {
    width: 28px;
    height: 28px;
  }
`
